import { createSlice } from "@reduxjs/toolkit";

import { fetchDynamicVariables } from "./actions"; // Import from actions instead

// Initial state
const initialState = {
  variables: [],
  loading: false,
  error: null,
  selectedTemplateId: null,
};

// Create the slice
const dynamicTemplateVariableSlice = createSlice({
  name: "dynamicTemplateVariable",
  initialState,
  reducers: {
    clearDynamicVariables: (state) => {
      state.variables = [];
      state.error = null;
    },
    setSelectedTemplateId: (state, action) => {
      state.selectedTemplateId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDynamicVariables.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDynamicVariables.fulfilled, (state, action) => {
        state.loading = false;
        state.variables = action.payload;
      })
      .addCase(fetchDynamicVariables.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearDynamicVariables, setSelectedTemplateId } = dynamicTemplateVariableSlice.actions;
export default dynamicTemplateVariableSlice.reducer;
